<template>
  <ValidationObserver v-slot="{ handleSubmit, invalid }">
    <div>
      <b-button variant="primary" class="mb-3" v-b-modal.two-factor-modal v-if="userInfo.enabled_2fa === 0">
        <i class="la la-check"/>
        Kích hoạt 2FA
      </b-button>
      <b-button variant="danger" class="mb-3" @click="remove2FA" v-if="userInfo.enabled_2fa === 1">
        <i class="la la-trash-o"/>
        Hủy 2FA
      </b-button>
    </div>
    <b-modal id="two-factor-modal" title="Kích hoạt 2FA" ok-title="Xác nhận" cancel-title="Đóng" size="md">
      <template #modal-header>
        <div class="d-flex justify-content-center w-100">
          <h4>Bảo mật 2FA</h4>
        </div>
      </template>
      <template #default>
        <div class="container-fluid">
          <div class="row">
            <div class="col-12">
              <b-form @submit.prevent="handleSubmit(onSubmit)">
                <div class="col-12">
                  <b class="text-primary">Hướng dẫn</b>
                  <p class="mb-2">
                    Để kích hoạt 2FA vui lòng nhập mã bên dưới bằng cách copy mã bên dưới vào ứng dụng cung cấp <b>Google
                                                                                                                   Authenticate</b>
                    hoặc <b>Authy</b>
                  </p>
                  <div class="input-group mb-2">
                    <input v-model="secret" type="text" class="form-control" style="color: #000000">
                    <div class="input-group-append" @click="copyToClipBoard()">
                    <span class="input-group-text btn-copy" ref="button-copy" style="font-size: 14px;">
                      <i class="las la-copy"></i>
                      Copy
                    </span>
                    </div>
                  </div>
                  <p class="mb-2 text-center">Hoặc <b>scan</b> mã QR dưới đây</p>
                  <p class="mb-2 text-center">
                    <img :src="qrcode" alt="qr" class="img-thumbnail">
                  </p>
                  <p class="mb-2 text-center">Sau khi đã hoàn thành trên ứng dụng và có <b>OTP</b> vui lòng nhập vào</p>
                </div>
                <ValidationProvider name="otp" v-slot="{errors}">
                  <b-form-group label="OTP">
                    <b-row>
                      <b-col>
                        <b-form-input
                          v-model="otp"
                          type="text"
                          :class="(errors.length > 0 ? ' is-invalid' : '')"
                          placeholder="Nhập mã OTP"
                          maxlength="6"
                        ></b-form-input>
                        <div class="invalid-feedback">
                          <span>{{ errors[0] }}</span>
                        </div>
                      </b-col>
                    </b-row>
                  </b-form-group>
                </ValidationProvider>
                <b class="text-red">Ghi chú</b>
                <ol style="list-style-type: circle">
                  <li>
                    Vui lòng liên hệ support nếu gặp bất cứ khó khăn gì trong việc cài đặt 2FA.
                  </li>
                </ol>
              </b-form>
              <span class="text-danger">{{ serverError }}</span>
            </div>
          </div>
        </div>
      </template>
      <template #modal-footer>
        <contact-button/>
        <b-button variant="primary" @click="handleSubmit(onSubmit)" :disabled="serverRequesting">Kích hoạt</b-button>
        <b-button variant="default" @click="$bvModal.hide(modalId)">Đóng</b-button>
      </template>
    </b-modal>
  </ValidationObserver>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import { localize } from 'vee-validate'
import api from '../../../store/api'

import { copyTextToClipboard } from '@/utils'
import ContactButton from '@/components/application/misc/ContactButton'

export default {
  name: 'TwoFactorAuthenticationModal',
  components: { ContactButton },
  data () {
    return {
      secret: '',
      qrcode: '',
      otp: ''
    }
  },
  props: {
    modalId: {
      type: String,
      default: 'two-factor-modal'
    }
  },
  created () {
    localize('en', {
      fields: {
        // 'username': { required: 'Tên đăng nhập không được để trống' },
        // 'password': { required: 'Mật khẩu không được để trống' },
        // 'pincode': { required: 'Mã an toàn không được để trống' }
      }
    })

    if (localStorage.getItem('2fa_secret')) {
      this.secret = localStorage.getItem('2fa_secret')
    } else {
      api.account.get2FASecret().then((res) => {
        this.secret = res.secret
        localStorage.setItem('2fa_secret', this.secret)
      })
    }
  },
  mounted () {
  },
  computed: {
    ...mapGetters({
      'userInfo': 'Auth/userInfoState',
      'authInfo': 'Auth/authUserState',
      'serverError': 'Setting/serverErrorsState',
      'serverRequesting': 'Setting/serverRequestingState'
    })
  },
  watch: {
    secret: function (newVal, oldVal) {
      this.qrcode = `https://chart.apis.google.com/chart?cht=qr&chs=300x300&chld=M|0&chl=` + encodeURIComponent(`otpauth://totp/${this.authInfo.user.username}?secret=${newVal}&issuer=Gom123`)
    }
  },
  methods: {
    ...mapActions({
      'loadMe': 'Auth/getMe'
    }),
    onSubmit ($event) {
      // call api
      api.account.enable2FA({
        'secret': this.secret.toString(),
        'otp': this.otp
      }).then((res) => {
        this.$swal({
          icon: 'success',
          title: 'Kích hoạt thành công'
        })

        this.loadMe()
        localStorage.removeItem('2fa_secret')

        this.$bvModal.hide(this.modalId)
      }).catch(() => {
        this.$swal({
          icon: 'error',
          title: 'Lỗi...',
          text: this.serverError
        })
      })
    },
    remove2FA () {
      this.$swal({
        title: 'Nhập mã OTP để hủy',
        input: 'text',
        inputAttributes: {
          autocapitalize: 'off'
        },
        showCancelButton: true,
        confirmButtonText: 'OK',
        cancelButtonText: 'Hủy',
        showLoaderOnConfirm: true
      }).then((result) => {
        if (result.isConfirmed) {
          api.account.disable2FA({
            'otp': result.value
          }).then((res) => {
            this.$swal({
              icon: 'success',
              title: 'Hủy thành công'
            })

            this.loadMe()
          }).catch(() => {
            this.$swal({
              icon: 'error',
              title: 'Lỗi...',
              text: this.serverError
            })
          })
        }
      })
    },
    copyToClipBoard () {
      copyTextToClipboard(this.secret)
      this.$refs['button-copy'].innerHTML = '<i class="las la-check"></i> Copied'
    }
  }
}
</script>
